import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import DateFmt from "../../../../common/typeFormatting/Date";
import IntegerFmt from "../../../../common/typeFormatting/IntegerFmt";
import PercentFmt from "../../../../common/typeFormatting/PercentFmt";
import Dollars from "../../../../common/typeFormatting/Dollars";

export default function StmtIssueGroup({planId, issueGroup}) {

    let history = useHistory();

    const goToEditGroup = (gid) => {
        history.push(`/options/plans/${planId}/groups/${gid}/edit`)
    }

    const goToAddOptions = (gid) => {
        history.push(`/options/plans/${planId}/groups/${gid}/options/add`);
    }

    return (
        <tbody>
            <tr>
                <td className="font-weight-bold" style={{fontSize: 18}} colSpan={8}>
                    {issueGroup.name}
                    <Button onClick={() => goToEditGroup(issueGroup.issueGroupId)}>Edit Group</Button>
                    <Button onClick={() => goToAddOptions(issueGroup.issueGroupId)}>Add Options</Button>
                </td>
            </tr>
            {issueGroup.options.length > 0 ?
                issueGroup.options.map(m => (
                <tr key={m.optionId}>
                    <td style={{fontSize: 14}}>{m.empName} </td>
                    <td style={{fontSize: 14}}><DateFmt>{m.issueDate}</DateFmt></td>
                    <td className="text-right" style={{fontSize: 14}}><IntegerFmt>{m.totalShares}</IntegerFmt></td>
                    <td className="text-right" style={{fontSize: 14}}><PercentFmt>{m.vestedPercentage}</PercentFmt></td>
                    <td className="text-right"  style={{fontSize: 16, backgroundColor: "rgb(243,243,243,1)"}}><IntegerFmt>{m.vestedShares}</IntegerFmt></td>
                    <td className="text-right"  style={{fontSize: 14}}><Dollars>{m.strikePrice}</Dollars></td>
                    <td className="text-right"  style={{fontSize: 16, backgroundColor: "rgb(243,243,243,1)"}}><Dollars>{m.priceDifference}</Dollars></td>
                    <td className="text-right"  style={{fontSize: 16, backgroundColor: "rgb(235,235,235,1)"}}><Dollars>{m.vestedValue}</Dollars></td>
                    <td className="text-right" style={{fontSize: 14}}><DateFmt>{m.expirationDate}</DateFmt></td>
                    <td className="text-right" style={{fontSize: 14}}>...</td>
                </tr>                
            ))
            : <tr><td>There are no options issued in this group yet...</td></tr>
            }            
        </tbody>
    );
}